import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { AddressInput } from "@/components/AddressInput";
import parentApi from "@/lib/parentApi";
import { toast } from "sonner";

/** Parent edits the name + billing address printed on tuition invoices and receipts. */
export function ParentProfileDialog({ open, me, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setName(me?.name || ""); setAddress(me?.address || ""); } }, [open, me]);

  const save = async () => {
    setBusy(true);
    try { await parentApi.put("/parent/me", { name, address }); toast.success("Billing details saved"); onSaved?.(); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="parent-profile-dialog">
        <DialogHeader>
          <DialogTitle>Billing details</DialogTitle>
          <DialogDescription>Printed under “Billed to” on tuition invoices and receipts.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Full name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} maxLength={120} className="h-10 w-full rounded-lg border border-slate-200 px-3 text-sm outline-none focus:border-primary" data-testid="parent-profile-name" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Billing address</label>
            <AddressInput value={address} onChange={(a) => setAddress(a)} testid="parent-profile-address" placeholder="123 Main Street, Atlanta, GA 30303" />
          </div>
        </div>
        <DialogFooter>
          <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-3 py-2 text-sm" data-testid="parent-profile-cancel">Cancel</button>
          <button type="button" onClick={save} disabled={busy} className="inline-flex items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white disabled:opacity-60" data-testid="parent-profile-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
